/**
 * @generated SignedSource<<3e48d010ad11ebf6830434e05abb9d11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivacyCookieConsentManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Platform",
        "kind": "LinkedField",
        "name": "platform",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PrivacyCookieConsent_platform"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PrivacyCookieConsentManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Platform",
        "kind": "LinkedField",
        "name": "platform",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieConsentBannerReadMoreTargetPageSlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5405cf3b992d29af4a3190809c1131e7",
    "id": null,
    "metadata": {},
    "name": "PrivacyCookieConsentManagerQuery",
    "operationKind": "query",
    "text": "query PrivacyCookieConsentManagerQuery {\n  platform {\n    ...PrivacyCookieConsent_platform\n    id\n  }\n}\n\nfragment PrivacyCookieConsent_platform on Platform {\n  cookieConsentBannerReadMoreTargetPageSlug\n}\n"
  }
};

node.hash = "721a2d58427c686b4070a52f0b66caf2";

module.exports = node;
